import { ValidateErrorEntity } from '../../types/forms/antd'

export default function isValidateErrorEntity(e: unknown): e is ValidateErrorEntity {
    return (
        typeof e === 'object' &&
        e !== null &&
        'errorFields' in e &&
        'values' in e &&
        'outOfDate' in e
    )
}
